import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanMatch,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanMatch, CanActivate {
    /**
     * Constructor
     */

    constructor(private _authService: AuthService, private _router: Router) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can match
     *
     * @param route
     * @param segments
     */
    canMatch(
        route: Route,
        segments: UrlSegment[]
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this._check(segments);
    }

    // canActivate(
    //     route: ActivatedRouteSnapshot,
    //     state: RouterStateSnapshot
    // ) {

    //     debugger;
    //    // const urlTree = this._router.parseUrl(`sign-in`);
    //     var isAuthorized = this._authService.isCheckURL();


    //     if (isAuthorized === false) {
    //         //alert("Access DENIED, user doesn't have access to these forms");
    //         this._router.navigate(['/norights/norights']);
    //         //const urlTree = this._router.parseUrl(`sign-in`);
    //         //this._router.navigate(['/Page-Not-Found'], { queryParams: { returnUrl: state.url }});
    //         return false;
    //     } else {
    //        // alert('Access AUTHORIZED');
          
    //     }
    //     return isAuthorized;
    // }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      
    
        var isAuthorized = this._authService.isCheckURL();
    
        if (!isAuthorized) {
            console.warn(`Access DENIED to ${state.url}`);
            this._router.navigate(['/norights/norights']);
            return false;
        } else {
            console.info(`Access AUTHORIZED to ${state.url}`);
        }
    
        return isAuthorized;
    }
    
    

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param segments
     * @private
     */
    private _check(segments: UrlSegment[]): Observable<boolean | UrlTree> {
        // Check the authentication status
        return this._authService.check().pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL = `/${segments.join('/')}`;
                    //const urlTree = this._router.parseUrl(`sign-in?redirectURL=${redirectURL}`);

                    const urlTree = this._router.parseUrl(`sign-in`);

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
    }
}
